import { render } from "./CurrencyCarousel.vue?vue&type=template&id=4de22f50&scoped=true"
import script from "./CurrencyCarousel.vue?vue&type=script&lang=js"
export * from "./CurrencyCarousel.vue?vue&type=script&lang=js"

import "./CurrencyCarousel.vue?vue&type=style&index=0&id=4de22f50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de22f50"]])

export default __exports__